import {useCallback} from 'react'
import {useDispatch} from 'react-redux'

import {trackEvent} from '../../../analytics/modules/actions'
import {
  Action,
  Category,
  Entity,
  Page,
  Team
} from '../../../analytics/types/Events'

const dispatchedRoomIds = new Set<string>()

const useImageErrorHandler = (roomId: string, page: Page) => {
  const dispatch = useDispatch()

  const handleImageError = useCallback(() => {
    if (!dispatchedRoomIds.has(roomId)) {
      dispatch(
        trackEvent({
          category: Category.System,
          entity: Entity.RoomImage,
          action: Action.Errored,
          team: Team.Select,
          page,
          payload: {
            errorType: {
              roomId
            }
          }
        })
      )

      dispatchedRoomIds.add(roomId)
    }
  }, [dispatch, page, roomId])

  return handleImageError
}

export default useImageErrorHandler
